module.exports = __webpack_public_path__ + "main/assets/public/player-media-session/playing-512.a159e1b9f563ce9f.jpg";